const translation = {
  nav: {
    home: "Strona główna",
    categories: "Kategorie",
    spreadsheet: "Kakobuy Spreadsheet",
    guide: "Poradnik",
    shoppingGuide: "Poradnik zakupowy",
    faq: "FAQ",
    buyNow: "Buy It Now",
  },
  hero: {
    title: "Kakobuy Spreadsheet Polska – Największa baza Kakobuy Finds",
    subtitle: "Znajdź najlepsze produkty z Kakobuy szybciej dzięki naszej uporządkowanej bazie Spreadsheet. Sneakersy, moda, akcesoria i najpopularniejsze produkty w jednym miejscu.",
    ctaPrimary: "Przeglądaj Kakobuy Spreadsheet",
    ctaSecondary: "Dowiedz się jak działa Kakobuy",
    trust1: "Aktualizowane listy produktów",
    trust2: "Kategorie według popularności",
    trust3: "Przewodnik dla Polski",
    trust4: "Bezpieczne wskazówki zakupowe",
    buyNow: "Buy It Now",
  },
  about: {
    label: "Czym jest Kakobuy Spreadsheet?",
    title1: "Zorganizowana baza",
    title2: "najlepszych Kakobuy Finds",
    stat1Label: "Produktów",
    stat2Label: "Kategorii",
    stat3Label: "Aktualizacja",
    stat4Label: "Polska Edycja",
  },
  comparison: {
    title: "Dlaczego warto używać Kakobuy Spreadsheet?",
    subtitle: "Porównanie z tradycyjnym wyszukiwaniem produktów",
    feature: "Funkcja",
    spreadsheet: "Kakobuy Spreadsheet",
    normal: "Normalne wyszukiwanie",
    f1: "Organizacja",
    f1s: "⭐⭐⭐⭐⭐",
    f1n: "⭐⭐",
    f2: "Oszczędność czasu",
    f2s: "Tak",
    f2n: "Nie",
    f3: "Kategorie",
    f3s: "Tak",
    f3n: "Brak",
    f4: "Porównanie produktów",
    f4s: "Łatwe",
    f4n: "Trudne",
    f5: "Początkujący użytkownik",
    f5s: "Idealne",
    f5n: "Trudniejsze",
  },
  categories: {
    label: "Kategorie",
    title: "Przeglądaj najpopularniejsze Finds",
    goto: "Przejdź do kategorii →",
    sectionTitle: "Kategorie produktów Kakobuy Spreadsheet",
    imageAlt: "Zdjęcie kategorii",
  },
  howItWorks: {
    title: "Jak działa Kakobuy Spreadsheet?",
    step1Title: "Znajdź produkt",
    step1Desc: "Przeglądaj uporządkowane kategorie i znajdź interesujące Cię produkty w kilka minut.",
    step2Title: "Sprawdź informacje",
    step2Desc: "Zapoznaj się ze szczegółami produktu, opiniami innych użytkowników i zdjęciami QC.",
    step3Title: "Przejdź do zakupu",
    step3Desc: "Kliknij w link i przejdź bezpośrednio do produktu na platformie Kakobuy.",
  },
  whyUs: {
    title: "Dlaczego użytkownicy wybierają nasz Spreadsheet?",
    card1Title: "Szybsze wyszukiwanie",
    card1Desc: "Gotowe listy pozwalają znaleźć produkty w kilka minut, zamiast tracić godziny na samodzielne przeszukiwanie.",
    card2Title: "Lepsza organizacja",
    card2Desc: "Kategorie i filtry pomagają porównać wiele produktów jednocześnie i wybrać najlepszą opcję.",
    card3Title: "Mniej błędów",
    card3Desc: "Poradniki i wskazówki pomagają uniknąć złych decyzji zakupowych i nieudanych zamówień.",
  },
  safety: {
    title: "Bezpieczeństwo zakupów Kakobuy",
    desc: "Kakobuy Spreadsheet jest narzędziem informacyjnym. Przed zakupem zawsze sprawdzaj sprzedawcę, opinie, zdjęcia QC oraz szczegóły produktu.",
    check1: "Zdjęcia QC",
    check1Desc: "Ocena jakości produktu przed wysyłką",
    check2: "Opinie",
    check2Desc: "Wiarygodność sprzedawcy i produktu",
    check3: "Cena",
    check3Desc: "Unikanie podejrzanie niskich ofert",
    check4: "Dane sprzedawcy",
    check4Desc: "Weryfikacja historii i ocen",
  },
  articles: {
    title: "Poradniki i aktualności",
    highlight: "Kakobuy Finds",
    readMore: "Czytaj więcej →",
    label: "Artykuły SEO",
    mainTitle: "Kakobuy Spreadsheet – Kompletny przewodnik dla początkujących 2026",
    mainLabel: "Przewodnik",
    article1Title: "Jak czytać zdjęcia QC na Kakobuy",
    article1Label: "Poradnik QC",
    article2Title: "Kakobuy vs Pandabuy – porównanie 2026",
    article2Label: "Porównanie",
    article3Title: "10 najlepszych Kakobuy Finds 2026",
    article3Label: "Ranking",
    article3Desc: "Lista najpopularniejszych produktów, których szukają Polacy na Kakobuy.",
    article4Title: "Kakobuy Polska – jak zamawiać z Polski",
    article4Label: "Polska",
    article4Desc: "Kompletny poradnik zamawiania i wysyłki Kakobuy do Polski krok po kroku.",
    article5Title: "Kakobuy vs Superbuy – pełne porównanie",
    article5Label: "Porównanie",
    article5Desc: "Który chiński agent zakupowy jest lepszy dla polskich kupujących?",
    article6Title: "Jak bezpiecznie kupować na Kakobuy",
    article6Label: "Bezpieczeństwo",
    article6Desc: "Wskazówki bezpieczeństwa i jak unikać oszustw na Kakobuy.",
    article7Title: "Najlepsze sneakersy z Kakobuy 2026",
    article7Label: "Sneakersy",
    article7Desc: "Przegląd najlepszych modeli sneakersów dostępnych przez Kakobuy.",
    article8Title: "Kakobuy shipping do Polski – wszystko co musisz wiedzieć",
    article8Label: "Wysyłka",
    article8Desc: "Metody wysyłki, koszty, czas dostawy i porady dla polskich użytkowników.",
    article9Title: "Kakobuy dla początkujących – pierwsze zamówienie",
    article9Label: "Początkujący",
    article9Desc: "Instrukcja krok po kroku dla osób pierwszy raz kupujących przez Kakobuy.",
    article10Title: "Top Kakobuy Finds – streetwear edycja 2026",
    article10Label: "Streetwear",
    article10Desc: "Najlepsze streetwearowe znaleziska na Kakobuy w tym sezonie.",
    article11Title: "Kakobuy Spreadsheet – jak znaleźć ukryte perełki",
    article11Label: "Poradnik",
    article11Desc: "Zaawansowane techniki wyszukiwania unikalnych produktów w arkuszu.",
    article12Title: "Kakobuy agent vs bezpośrednie zamówienie",
    article12Label: "Porównanie",
    article12Desc: "Czy warto korzystać z agenta Kakobuy? Analiza zalet i wad.",
  },
  testimonial: {
    label: "Recenzja użytkownika",
    title1: "Kakobuy Spreadsheet",
    title2: "to ogromna oszczędność czasu",
    quote: "Od kiedy korzystam z Kakobuy Spreadsheet, znajdowanie ciekawych produktów zajmuje mi dosłownie kilka minut. Wcześniej spędzałem godziny na przeszukiwaniu różnych kategorii. Polecam każdemu, kto chce szybko znaleźć sprawdzone Kakobuy Finds bez zbędnego wysiłku.",
    author: "Michał, Warszawa",
  },
  cta: {
    title: "Odkryj najlepsze Kakobuy Finds",
    subtitle: "Dołącz do tysięcy zadowolonych użytkowników i zacznij znajdować najlepsze produkty już dziś.",
    button: "Kakobuy Spreadsheet",
  },
  faq: {
    title: "Często zadawane pytania",
    q1: "Co to jest Kakobuy Spreadsheet?",
    a1: "Kakobuy Spreadsheet to uporządkowana lista produktów, która pomaga użytkownikom szybciej znaleźć popularne produkty na platformie Kakobuy. Zawiera kategorie takie jak buty, odzież, akcesoria i wiele więcej.",
    q2: "Czy Kakobuy Spreadsheet jest darmowy?",
    a2: "Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy go społeczności, aby ułatwić wszystkim użytkownikom znajdowanie najlepszych produktów.",
    q3: "Jak często aktualizujecie Spreadsheet?",
    a3: "Regularnie aktualizujemy nasze listy produktów, dodając nowe kategorie i usuwając nieaktualne pozycje. Ostatnia aktualizacja miała miejsce w 2026 roku.",
    q4: "Czy Kakobuy jest bezpieczny?",
    a4: "Bezpieczeństwo zależy od sprawdzania produktów, sprzedawców i dokładnej analizy przed zakupem. Nasz Spreadsheet zawiera wskazówki, które pomogą Ci podejmować bezpieczne decyzje zakupowe.",
  },
  footer: {
    subscribeTitle: "Zapisz się do bazy Kakobuy",
    subscribeDesc: "Otrzymuj najnowsze aktualizacje Kakobuy Spreadsheet i nowe Finds prosto na swoją skrzynkę.",
    emailPlaceholder: "Twój email",
    subscribeBtn: "Wyślij →",
    navTitle: "Nawigacja",
    navHome: "Strona główna",
    navSpreadsheet: "Kakobuy Spreadsheet",
    navGuide: "Poradnik",
    navFAQ: "FAQ",
    contactTitle: "Kontakt",
    copyright: "© 2026 KakobuyFinds.fit. Wszelkie prawa zastrzeżone.",
    privacy: "Polityka prywatności",
    terms: "Regulamin",
  },
};

export default translation;